import { api } from "app/views/utils/api"
import * as moment from "moment"
import settings from "settings"
import UIkit from 'uikit'

const GET_REWARDS = 'rewards/GET_REWARDS'
const SET_GIFT_CARD_CATALOGUE = 'rewards/SET_GIFT_CARD_CATALOGUE'
const SET_CRYPTO_CATALOGUE = 'rewards/SET_CRYPTO_CATALOGUE'
const GET_CREDITS = 'rewards/GET_CREDITS'
const SET_LOADING_ENABLING = 'rewards/SET_LOADING_ENABLING'
const SET_LOADING_REWARDS_CATALOGUE = 'rewards/SET_LOADING_REWARDS_CATALOGUE'
const SET_CATALOG_BY_ORGANIZATION = 'rewards/SET_CATALOG_BY_ORGANIZATION'
const SET_CLAIMED_REWARDS_HISTORY = 'rewards/SET_CLAIMED_REWARDS_HISTORY'
const SET_CLAIMING_REWARD = 'rewards/SET_CLAIMING_REWARD'
const SET_REWARDS_ADMIN_STATUS = 'rewards/SET_REWARDS_ADMIN_STATUS'
const SET_REWARDS_ADMIN_STATUS_LOADING = 'rewards/SET_REWARDS_ADMIN_STATUS_LOADING'

const initialState = {
  rewardsAdminStatus: false,
  rewardsAdminStatusLoading: true,

  rewardsByOrganization: {},
  loading: true,

  catalogByOrganizationId: {},
  loadingCatalogByOrganization: true,

  giftCardCatalogue: null,
  cryptoCatalogue: null,
  loadingRewardsCatalogue: false,

  currentOrganizationTotalClaimed: null,
  currentOrganizationTotalActive: null,
  currentOrganizationTotalPurchased: null,
  loadingCredits: true,

  loadingEnabling: false,

  claimedRewardsHistory: null,
  claimedRewardsChart: null,
  loadingClaimedRewards: true,

  claimingReward: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_REWARDS_ADMIN_STATUS_LOADING:
      const { rewardsAdminStatusLoading } = action
      return {
        ...state,
        rewardsAdminStatusLoading
      }
    case SET_REWARDS_ADMIN_STATUS:
      const { rewardsAdminStatus } = action
      return {
        ...state,
        rewardsAdminStatus,
        rewardsAdminStatusLoading: false,
      }
    case SET_LOADING_REWARDS_CATALOGUE:
      const { loadingRewardsCatalogue } = action
      return {
        ...state,
        loadingRewardsCatalogue,
      }
    case SET_CATALOG_BY_ORGANIZATION:
      const { organizationUuid, items } = action
      return {
        ...state,
        catalogByOrganizationId: {
          ...state.catalogByOrganizationId,
          [organizationUuid]: items.reduce((prev, item) => {
            if (item.giftCard) {
              if (!prev.giftCard) {
                prev.giftCard = [item]
              } else {
                prev.giftCard.push(item)
              }
            }
            if (item.crypto) {
              if (!prev.crypto) {
                prev.crypto = [item]
              } else {
                prev.crypto.push(item)
              }
            }
            return prev
          }, {})
        },
        loadingCatalogByOrganization: false,
      }
    case SET_GIFT_CARD_CATALOGUE:
      const { giftCardCatalogue } = action
      return {
        ...state,
        giftCardCatalogue,
        loadingRewardsCatalogue: false,
      }
    case SET_LOADING_ENABLING:
      const { loadingEnabling } = action
      return {
        ...state,
        loadingEnabling,
      }
    case GET_CREDITS:
      const { currentOrganizationTotalClaimed, currentOrganizationTotalActive, currentOrganizationTotalPurchased } = action
      return {
        ...state,
        currentOrganizationTotalClaimed,
        currentOrganizationTotalActive,
        currentOrganizationTotalPurchased,
        loadingCredits: false
      }
    case GET_REWARDS:
      const { rewardsByOrganization } = action
      return {
        ...state,
        loading: false,
        rewardsByOrganization: (rewardsByOrganization.organizations || []).reduce((prev, item) => {
          prev[item.organizationUuid] = item
          return prev
        }, {})
      }
    case SET_CLAIMING_REWARD:
      const { claimingReward } = action
      return {
        ...state,
        claimingReward
      }
    case SET_CLAIMED_REWARDS_HISTORY:
      const { claimedRewardsHistory } = action
      return {
        ...state,
        claimedRewardsHistory,
        claimedRewardsChart: Object.values(
          claimedRewardsHistory.reduce((prev, curr) => {
            let { time } = curr.claimed
            const timeKey = moment(time).format('YYYYMMDD')
            if (!prev[timeKey]) {
              prev[timeKey] = {
                id: timeKey,
                Rewards: 1,
                title: moment(time).format('MMM YY')
              }
            } else {
              prev[timeKey].Rewards += 1
            }
            return prev
          }, {})
        ),
        loadingClaimedRewards: false,
      }
    default:
      return state
  }
}

export function getRewards(callback) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.rewards}/rewards`,
      idToken: state.auth.user.idToken,
    }).then(({ data }) => {
      dispatch({
        type: GET_REWARDS,
        rewardsByOrganization: data
      })
      if (callback && typeof callback === 'function') {
        callback()
      }
    }).catch((error) => {
      console.error(error)
    })
  }
}

export function getRewardsCatalogByOrganization(organizationUuid) {
  return async (dispatch, getState) => {
    const state = getState()
    const { data } = await api({
      method: 'get',
      url: `${settings.urls.rewards}/rewards/${organizationUuid}/catalog`,
      idToken: state.auth.user.idToken,
    })
    dispatch({
      type: SET_CATALOG_BY_ORGANIZATION,
      organizationUuid,
      items: data.items,
    })
  }
}

export function getRewardsCardsCatalogue() {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_LOADING_REWARDS_CATALOGUE,
      loadingRewardsCatalogue: true,
    })
    const state = getState()
    const { data } = await api({
      method: 'get',
      url: `${settings.urls.rewards}/rewards/catalog`,
      idToken: state.auth.user.idToken,
    })
    dispatch({
      type: SET_GIFT_CARD_CATALOGUE,
      giftCardCatalogue: data.items,
    })
  }
}

async function getRewardsByOrganization(state, organizationUuid, unclaimed = false) {
  const { data } = await api({
    method: 'get',
    url: `${settings.urls.rewards}/rewards/${organizationUuid}`,
    idToken: state.auth.user.idToken,
    params: {
      unclaimed,
    },
    headers: {
      accept: 'application/json'
    }
  })
  return data
}

export function getCredits(organizationUuid) {
  return async (dispatch, getState) => {
    const state = getState()
    const promises = []
    promises.push(new Promise(async (resolve, reject) => {
      const data = await getRewardsByOrganization(state, organizationUuid)
      resolve(data)
    }))
    promises.push(new Promise(async (resolve, reject) => {
      const data = await getRewardsByOrganization(state, organizationUuid, true)
      resolve(data)
    }))
    const responses = await Promise.all(promises)
    const claimed = responses[0].counts[0].count
    const unclaimed = responses[1].counts[0].count
    dispatch({
      type: GET_CREDITS,
      currentOrganizationTotalClaimed: claimed,
      currentOrganizationTotalActive: unclaimed,
      currentOrganizationTotalPurchased: claimed + unclaimed,
    })
  }
}

export function enableRewards(organizationUuid, enabled) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_LOADING_ENABLING,
      loadingEnabling: true
    })
    const state = getState()
    return api({
      method: 'put',
      url: `${settings.urls.rewards}/rewards/${organizationUuid}/enabled`,
      idToken: state.auth.user.idToken,
      data: JSON.stringify(enabled)
    }).then(({ data }) => {
      dispatch(getEnabledRewardsStatus(organizationUuid, () => {
        dispatch({
          type: SET_LOADING_ENABLING,
          loadingEnabling: false
        })
      }))
    }).catch((error) => {
      dispatch({
        type: SET_LOADING_ENABLING,
        loadingEnabling: false
      })
    })
  }
}

export function getEnabledRewardsStatus(organizationUuid, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_REWARDS_ADMIN_STATUS_LOADING,
      loadingEnabling: true
    })
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.rewards}/rewards/${organizationUuid}/enabled`,
      idToken: state.auth.user.idToken,
    }).then(({ data }) => {
      dispatch({
        type: SET_REWARDS_ADMIN_STATUS,
        rewardsAdminStatus: data
      })
      if (typeof callback === 'function') {
        callback()
      }
    }).catch((error) => {
      dispatch({
        type: SET_REWARDS_ADMIN_STATUS_LOADING,
        rewardsAdminStatusLoading: false
      })
    })
  }
}

export function claimUserReward(organizationUuid, typeUuid, metadata, callback, text) {
  return async (dispatch, getState) => {
    const state = getState()
    try {
      dispatch({
        type: SET_CLAIMING_REWARD,
        claimingReward: true
      })
      const { data } = await api({
        method: 'post',
        url: `${settings.urls.rewards}/rewards/${organizationUuid}/claim`,
        idToken: state.auth.user.idToken,
        data: {
          userUuid: state.hacker.profile.user_id,
          typeUuid,
          metadata,
        }
      })
      if (callback && typeof callback === 'function') {
        UIkit.modal.alert(`<p>${text}</p>`).then(() => {
          callback()
        })
      }
    } catch (e) {
      UIkit.modal.alert(`<p>Something seems to be wrong with your reward claim. Please contact suppoert at <a href="mailto:support@hackedu.com">support@hackedu.com</a></p>`)
    }
    dispatch({
      type: SET_CLAIMING_REWARD,
      claimingReward: false
    })
  }
}

export function getClaimedRewardsHistory(organizationUuid, startDate, endDate) {
  return async (dispatch, getState) => {
    const state = getState()
    try {
      const { data } = await api({
        method: 'get',
        url: `${settings.urls.rewards}/rewards/${organizationUuid}/claim`,
        idToken: state.auth.user.idToken,
        params: {
          startDate,
          endDate,
        }
      })
      dispatch({
        type: SET_CLAIMED_REWARDS_HISTORY,
        claimedRewardsHistory: data.items,
      })
    } catch (e) {
      console.error({ e })
    }
  }
}

